import Flex from 'components/Flex'
import Tree from 'components/Tree'
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled(Flex)`
  padding: 20px 20px 20px 0;
  gap: 5px;
`

// FilterDiv sets destroyPopupOnHide, so this tree unmounts every time the filter
// dropdown closes. The checked keys therefore live in CourseFilter, which stays
// mounted across that. They used to live in a module-level variable, which
// outlived the page itself — so returning to Courses with no filter applied
// still showed the previous visit's boxes ticked.
const DegreeAndDepartmentFilter = ({
  degreeList,
  setDegreeList,
  setSpecializationList,
  checkedKeys = [],
  setCheckedKeys,
}) => {
  // Which department does a specialisation hang off? Mirrors the Students
  // filter, which resolves the parent the same way.
  const parentDepartmentOf = specializationId => {
    let parent = null
    degreeList?.forEach(degree => {
      degree?.children?.forEach(department => {
        if (department?.children?.some(spec => spec?.value === specializationId)) {
          parent = department?.value
        }
      })
    })
    return parent
  }

  const onCheck = (activeKeys, info) => {
    setCheckedKeys(activeKeys)

    // Extract department/stream IDs from checked nodes
    let activeDepartmentIds = info?.checkedNodes
      ?.filter(item => {
        return item?.value && !item?.isSpecialization && item?.children
      })
      ?.map(id => id?.value)

    // Ticking a department auto-ticks its specialisations, and the API ANDs
    // degreeStreamMapId with specializationIds — so passing both would hide
    // every course in that department with no specialisation mapped, which is
    // almost all of them. The department filter already covers its own
    // specialisations, so only send specialisations picked on their own (their
    // parent is half-checked and therefore absent from checkedNodes).
    const checkedDepartmentIds = new Set(activeDepartmentIds || [])

    let activeSpecializationIds = info?.checkedNodes
      ?.filter(item => {
        return (
          item?.value &&
          item?.isSpecialization &&
          !checkedDepartmentIds.has(parentDepartmentOf(item?.value))
        )
      })
      ?.map(id => id?.value)

    setDegreeList(activeDepartmentIds)
    if (setSpecializationList) {
      setSpecializationList(activeSpecializationIds)
    }
  }

  return (
    <>
      <br></br>
      <Tree treeData={degreeList} checkedKeys={checkedKeys} onCheck={onCheck} />
    </>
  )
}

export default DegreeAndDepartmentFilter
